module.exports = __webpack_public_path__ + "img/home-button.8e4f7247.svg";